export default function() {
	const $pagination = $('.p-pagination');
	const $pagination_item = $('.p-pagination__item');

	if($pagination_item .length > 1) {
		$pagination.addClass('p-pagination--02');
	}
}
